import { getAssetPath } from '../assetPath';

const createRotateControl = function (fabricObject) {
  const icon = getAssetPath("/assets/images/rotate.svg?inline");
  let img = new Image();
  img.src = icon;
  img.crossOrigin = "Anonymous";

  const control = new window.fabric.Control({
    x: -0.5,
    y: 0.5,
    cursorStyle: "pointer",
    actionHandler: window.fabric.controlsUtils.rotationWithSnapping,
    actionName: "rotate",
    render: renderIcon,
    cornerSize: 24,
    withConnection: true,
  });


  fabricObject.controls = fabricObject.controls || {};
  fabricObject.controls.bl = control;
  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    let size = 24;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(window.fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, size, size);
    ctx.restore();
  }
};

const createResizeControl = function (fabricObject) {
  const icon = getAssetPath("/assets/images/resize.svg?inline");
  let img = new Image();
  img.src = icon;
  img.crossOrigin = "Anonymous";

  const control = new window.fabric.Control({
    x: 0.5,
    y: 0.5,
    cursorStyle: "se-resize",
    actionHandler: window.fabric.controlsUtils.scalingEqually,
    actionName: 'scale', // Use string actionName instead of a function reference
    render: renderIcon,
    cornerSize: 24,
    withConnection: true,
  });

  fabricObject.controls = fabricObject.controls || {};
  fabricObject.controls.br = control;
  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    let size = 24;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(window.fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, size, size);
    ctx.restore();
  }
};

const createColorControl = function (fabricObject, editorInstance) {
  const icon = getAssetPath("/assets/images/colorIcon.svg?inline");
  let img = new Image();
  img.src = icon;
  img.crossOrigin = "Anonymous";

  const control = new window.fabric.Control({
    x: 0.5,
    y: -0.5,
    cursorStyle: "pointer",
    mouseUpHandler: colorObject,
    render: renderIcon,
    cornerSize: 24,
    withConnection: true,
  });

  fabricObject.controls = fabricObject.controls || {};
  fabricObject.controls.mtr = control;

  function colorObject(eventData, transform) {
    editorInstance.$refs.toolbar.colorize(transform);
  }

  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    if (fabricObject.type === 'path' || fabricObject.type === 'group') {
      let size = 24;
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(window.fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(img, -size / 2, -size / 2, size, size);
      ctx.restore();
    }
  }
};


const createDeleteControl = function (fabricObject) {
  const icon = getAssetPath("/assets/images/delete.svg?inline");
  let img = new Image();
  img.src = icon;
  img.crossOrigin = "Anonymous";

  const control = new window.fabric.Control({
    x: -0.5,
    y: -0.5,
    cursorStyle: "pointer",
    mouseUpHandler: deleteObject,
    render: renderIcon,
    cornerSize: 24,
    withConnection: true,
  });

  function deleteObject(eventData, transform) {
    let target = transform.target;
    let canvas = target.canvas;
    canvas.remove(target);
    canvas.requestRenderAll();
  }

  fabricObject.controls = fabricObject.controls || {};
  fabricObject.controls.deleteControl = control;
  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    let size = 24;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(window.fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, size, size);
    ctx.restore();
  }
};

export default function initCustomControls(object, editorInstance) {
  createColorControl(object, editorInstance);
  createDeleteControl(object);
  createRotateControl(object);
  createResizeControl(object);
}
